export default __webpack_public_path__ + "static/media/as we fade iii.68471681.jpg";